(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["abide-product-videos"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var vids = Array.prototype.slice.call(root.querySelectorAll('video'));
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var labelOn = root.dataset.labelOn || 'Turn sound on';
      var labelOff = root.dataset.labelOff || 'Turn sound off';
      function load(v) {
        if (!v.getAttribute('src') && v.dataset.src) v.src = v.dataset.src;
      }
      function play(v) {
        var pr = v.play();
        if (pr && pr.catch) pr.catch(function () {});
      }
      function setState(v, on) {
        var item = v.closest('.ab-pvid__item');
        var b = item && item.querySelector('.ab-pvid__sound');
        v.muted = !on;
        if (item) item.classList.toggle('is-sound', on);
        if (b) {
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          b.setAttribute('aria-label', on ? labelOff : labelOn);
        }
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var v = e.target;
            if (e.isIntersecting) {
              load(v);
              if (!reduce || !v.muted) play(v);
            } else {
              v.pause();
              if (!v.muted) setState(v, false);
            }
          });
        }, { threshold: 0.5 });
        vids.forEach(function (v) { io.observe(v); });
      } else {
        vids.forEach(load);
      }
      root.addEventListener('click', function (ev) {
        var item = ev.target.closest('.ab-pvid__item');
        if (!item) return;
        var v = item.querySelector('video');
        if (!v) return;
        load(v);
        var turnOn = v.muted;
        vids.forEach(function (o) { if (o !== v && !o.muted) setState(o, false); });
        if (turnOn) {
          setState(v, true);
          try { v.currentTime = 0; } catch (err) {}
          play(v);
        } else {
          setState(v, false);
          if (reduce) v.pause();
        }
      });
    }
    function boot() {
      document.querySelectorAll('[data-ab-pvid]').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:block:select', boot);
  })();
  } catch(e) { console.error(e); }
})();

})();
